


import { useState } from "react";
import {  useNavigate } from "react-router-dom";
import { loginUser, verifyMfaLogin } from "../../api/authServices";
import Swal from "sweetalert2";
export default function SignIn() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [password, setPassword] = useState("");
  const [mfaRequired, setMfaRequired] = useState(false);
  const [mfaChallengeToken, setMfaChallengeToken] = useState("");
  const [mfaToken, setMfaToken] = useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const payload = {
        first_name: firstName.trim(),
        password: password.trim(),
      };

      const response = await loginUser(payload);

      if (response?.mfaRequired && response?.mfaChallengeToken) {
        setMfaChallengeToken(response.mfaChallengeToken);
        setMfaRequired(true);
        setLoading(false);
        return;
      }

      await Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Login successful",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: "#0f172a",
        color: "#fff",
      });

      localStorage.setItem("token", response.token);
      localStorage.setItem(
        "user",
        JSON.stringify(response.user)
      );

      navigate("/dashboard");

    } catch (error) {
      console.log(error);

      setErrors({
        api:
          error?.response?.data?.message ||
          "Login failed",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMfaSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{6}$/.test(mfaToken)) {
      setErrors({
        api: "Please enter the 6-digit Google Authenticator code.",
      });
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const response = await verifyMfaLogin(
        mfaChallengeToken,
        mfaToken
      );

      await Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Login successful",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: "#0f172a",
        color: "#fff",
      });

      localStorage.setItem("token", response.token);
      localStorage.setItem(
        "user",
        JSON.stringify(response.user)
      );

      navigate("/dashboard");

    } catch (error) {
      console.log(error);

      setErrors({
        api:
          error?.response?.data?.message ||
          "Invalid Google Authenticator code.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center px-4"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1920&auto=format&fit=crop')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Card */}
      <div className="relative z-10 w-full max-w-md bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl shadow-2xl p-8">

        {/* Logo / Title */}
        <div className="mb-8 text-center">
          <h1 className="text-4xl font-bold text-white mb-2">
            Welcome Back
          </h1>

          <p className="text-slate-200">
            Sign in to continue to your CRM dashboard
          </p>
        </div>

        {/* Error */}
        {errors.api && (
          <div className="mb-4 bg-red-500/20 border border-red-400 text-red-100 px-4 py-3 rounded-xl text-sm">
            {errors.api}
          </div>
        )}

        {mfaRequired ? (
          <form onSubmit={handleMfaSubmit}>

            <div className="mb-5">
              <label className="block text-sm text-slate-200 mb-2">
                Google Authenticator Code
              </label>

              <input
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                placeholder="Enter 6-digit code"
                value={mfaToken}
                onChange={(e) => {
                  const value = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 6);

                  setMfaToken(value);

                  setErrors((prev) => ({
                    ...prev,
                    api: "",
                  }));
                }}
                className="w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 border border-white/20 focus:outline-none focus:ring-2 focus:ring-blue-400 text-center tracking-[0.4em]"
              />

              <p className="text-slate-300 text-sm mt-3">
                Enter the 6-digit code from Google Authenticator.
              </p>
            </div>

            <button
              type="submit"
              disabled={loading || mfaToken.length !== 6}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-xl font-medium transition duration-300 disabled:opacity-50"
            >
              {loading ? "Verifying..." : "Verify & Sign In"}
            </button>

            <button
              type="button"
              disabled={loading}
              onClick={() => {
                setMfaRequired(false);
                setMfaChallengeToken("");
                setMfaToken("");
                setErrors({});
              }}
              className="w-full mt-3 text-slate-200 hover:text-white py-2 text-sm"
            >
              Back to Sign In
            </button>

          </form>
        ) : (
          <form onSubmit={handleSubmit}>

          {/* First Name */}
          <div className="mb-5">
            <label className="block text-sm text-slate-200 mb-2">
              First Name
            </label>

            <input
              type="text"
              placeholder="Enter your first name"
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);

                setErrors((prev) => ({
                  ...prev,
                  firstName: "",
                }));
              }}
              className={`w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 focus:outline-none focus:ring-2 ${errors.firstName
                  ? "border border-red-400 focus:ring-red-400"
                  : "border border-white/20 focus:ring-blue-400"
                }`}
            />

            {errors.firstName && (
              <p className="text-red-300 text-sm mt-2">
                {errors.firstName}
              </p>
            )}
          </div>

          {/* Password */}
          <div className="mb-5 relative">
            <label className="block text-sm text-slate-200 mb-2">
              Password
            </label>

            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);

                setErrors((prev) => ({
                  ...prev,
                  password: "",
                }));
              }}
              className={`w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 focus:outline-none focus:ring-2 ${errors.password
                  ? "border border-red-400 focus:ring-red-400"
                  : "border border-white/20 focus:ring-blue-400"
                }`}
            />

            {errors.password && (
              <p className="text-red-300 text-sm mt-2">
                {errors.password}
              </p>
            )}

            <button
              type="button"
              onClick={() =>
                setShowPassword(!showPassword)
              }
              className="absolute right-4 top-[45px] text-slate-300"
            >
              {showPassword ? "🙈" : "👁"}
            </button>
          </div>

          {/* Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-xl font-medium transition duration-300 disabled:opacity-50"
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>

          </form>
        )}

        {/* Footer */}
        {/* <div className="mt-6 text-center text-sm text-slate-200">
          Don&apos;t have an account?{" "}
          <Link
            to="/signup"
            className="text-blue-300 hover:text-white font-medium"
          >
            Sign Up
          </Link>
        </div> */}
      </div>
    </div>
  );
}